import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import categoryActions from "../../../store/actions/items/categories/category.actions";
import { Link, useSearchParams } from "react-router-dom";

import "../../../styles/components/dialogs/categories/manageCategoriesDialogComponent.scss";
import AlertService from "../../../services/alerts/alert.service";
import validationHelper from "../../../helpers/validation.helper";
import { useEffect } from "react";

export const ManageCategoriesDialogComponent = ({ categoryActions, categories }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const queryParams = { getAll: true };
    try {
      await categoryActions.getCategories(queryParams);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleUpdate = (id) => {
    const queryParams = new URLSearchParams();
    queryParams.set("d", "category");
    queryParams.set("action", "update");
    queryParams.set("id", id);

    setSearchParams(queryParams);
  };

  const handleDelete = async (id) => {
    const userChoice = await AlertService.confirm("האם אתה בטוח שברצונך למחוק קטגוריה זו?", "שים לב, פעולה זו בלתי הפיכה וכל קבוצות הפריטים ששויכו לקטגוריה זו יהיה ניתנים לשיוך מחדש", "כן מחק", "בטל");
    if (!userChoice) return;

    const response = await categoryActions.deleteCategory(id);
    if (!validationHelper.validateHttpResponse(response)) {
      AlertService.error("מחיקת קטגוריה נכשלה. נסה שוב.", "אנא נסה שנית מאוחר יותר");
      return;
    }
    AlertService.success("קטגוריה נמחקה בהצלחה");
    fetchCategories();
  };

  const getNewCategoryContainerElement = () => {
    return (
      <div className="newCategoryContainer">
        <Link to="?d=category&action=add" className="addCategoryButton primaryButton">
          הוספה
        </Link>
      </div>
    );
  };

  const getExistingCategoriesContainerElement = () => {
    return (
      <div className="existingCategoryTable">
        <div className="tableHeader">
          <div>תמונה</div>
          <div>שם קטגוריה</div>
          <div>פעולות</div>
        </div>
        <div className="tableBody">
          {categories?.map((category) => (
            <div key={category.id} className="tableRow">
              <div className="categoryImage">
                <img src={category.imageURL || "https://via.placeholder.com/50"} alt={category.categoryName} />
              </div>
              <div className="categoryName">{category.categoryName}</div>
              <div className="categoryActions">
                <button className="actionButton connectButton">
                  <Link to={`?d=category&action=connect&id=${category.id}`}>
                    <i className="fa-solid fa-network-wired"></i>
                  </Link>
                </button>
                <button className="actionButton updateButton" onClick={() => handleUpdate(category.id)}>
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>
                <button className="actionButton deleteButton" onClick={() => handleDelete(category.id)}>
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="dialogContainer manageCategoriesContainer">
      <h1>ניהול קטגוריות</h1>
      {getNewCategoryContainerElement()}
      {getExistingCategoriesContainerElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.categoryReducer.categories?.items, // Subscribe to categories state from the reducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageCategoriesDialogComponent);
